import {Aggregation} from "./aggregation";

export function init() {
    new Aggregation().init();
}

window.o_global.eventLoader.onLoad(90, () => init());
